<script></script>

<div class="flex justify-center font-bold">
    <div
        style="font-weight:800; color:#7765AC; z-index: 2;"
        class="min-[260px]:text-4xl min-[320px]:text-5xl text-blue-300 pt-20 font-bold text-center"
    >
        Speak to a professional <p>mentor or therapist.</p>
    </div>
</div>
